import { useEffect } from 'react';
import { getThemeFromUrl } from '../utils/urlParams';
import { getThemeFromParentIframe } from '../utils/iframeDataAttributes';

/**
 * React hook для применения кастомной темы из URL параметров и iframe data-атрибутов
 *
 * Приоритет:
 * 1. URL параметры (высший приоритет)
 * 2. Data-атрибуты iframe
 * 3. Дефолтные значения из theme-variables.css
 *
 * @example
 * // В App.jsx или AppContent
 * function App() {
 *   useThemeCustomization();
 *   // ...
 * }
 *
 * // URL: ?primaryColor=#FF5733&fontFamily=Arial
 * // Или: <iframe data-primary-color="#FF5733" data-font-family="Arial">
 * // Результат: CSS переменные применены к :root
 */
export const useThemeCustomization = () => {
  useEffect(() => {
    try {
      // Получаем стилевые параметры из разных источников
      const urlTheme = getThemeFromUrl();
      const iframeTheme = getThemeFromParentIframe();

      // Объединяем темы (URL имеет приоритет над iframe data-attrs)
      const mergedTheme = {
        ...iframeTheme,   // Сначала data-атрибуты
        ...urlTheme,      // Потом URL параметры (перезаписывают)
      };

      // Проверяем есть ли кастомные параметры
      const hasCustomTheme = Object.keys(mergedTheme).length > 0;

      if (hasCustomTheme) {
        // Применяем CSS переменные к :root
        const root = document.documentElement;
        Object.entries(mergedTheme).forEach(([cssVar, value]) => {
          root.style.setProperty(cssVar, value);
        });

        console.log('[useThemeCustomization] Applied custom theme:', mergedTheme);
      } else {
        console.log('[useThemeCustomization] Using default theme (no custom parameters)');
      }
    } catch (error) {
      console.error('[useThemeCustomization] Error applying theme:', error);
    }
  }, []); // Выполняется только один раз при монтировании
};
